<template>
  <fragment>
    <div class="body-wrapper-inner">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="d-sm-flex gap-1 align-items-center mb-4">
              <h5 class="card-title fw-semibold mb-3 mb-sm-0 me-auto">Daftar Pemeriksaan</h5>
              <form @submit.prevent="getDataList" class="d-flex gap-1">
                <div class="input-group">
                  <input
                    v-model="cariTitle"
                    type="text"
                    class="form-control bg-light"
                    placeholder="Pencarian..."
                    autocomplete="off"
                  >
                  <button class="btn btn-primary">Cari</button>
                </div>
              </form>
            </div>
            <hr class="border-0 bg-primary pt-1 rounded my-4">

            <ul class="nav nav-pills mb-4 gap-1" id="pills-tab" role="tablist">
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link active"
                  id="pills-0-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-0"
                  type="button"
                  role="tab"
                  aria-controls="pills-0"
                  aria-selected="true"
                >Kesehatan Umum</button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="pills-1-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-1"
                  type="button"
                  role="tab"
                  aria-controls="pills-1"
                  aria-selected="false"
                >Kontrol Kehamilan</button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="pills-3-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-3"
                  type="button"
                  role="tab"
                  aria-controls="pills-3"
                  aria-selected="false"
                >Persalinan</button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="pills-4-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-4"
                  type="button"
                  role="tab"
                  aria-controls="pills-4"
                  aria-selected="false"
                >Postpartum</button>
              </li>
            </ul>

            <div class="tab-content" id="pills-tabContent">
              <div
                class="tab-pane fade show active"
                id="pills-0"
                role="tabpanel"
                aria-labelledby="pills-0-tab"
                tabindex="0"
              >
                <div class="table-responsive">
                  <table class="table align-middle table-striped table-hover">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th class="w-50" scope="col">
                          <a href="#" class="link-dark">
                            Nama Lengkap
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th scope="col">
                          <a href="#" class="link-dark">
                            NIK
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-nowrap" scope="col">Tujuan Pemeriksaan</th>
                        <th class="text-center" scope="col">
                          <a href="#" class="link-dark">
                            Tanggal
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            No. Antrian
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-end" scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          v-if="dataList.length == 0"
                          colspan="12"
                          align="center"
                        >There is no data for this page</td>
                      </tr>
                      <tr v-for="(req, idx) in dataList" :key="req.id">
                        <th scope="row">{{ idx + 1 }}</th>
                        <td class="text-nowrap">{{ req.fullname }}</td>
                        <td>{{ displayValue(req.nik) }}</td>
                        <td class="text-nowrap">
                          <ul v-if="req.examination_purpose" class="nav small flex-column">
                            <li
                              v-for="(item, index) in req.examination_purpose.split(',')"
                              :key="index"
                            >
                              <i class="ti ti-point-filled fs-1"></i>
                              {{ item }}
                            </li>
                          </ul>
                        </td>
                        <td class="text-center">{{ formatDate(req.examination_date) }}</td>
                        <td class="text-center">
                          <span class="badge text-bg-dark bg-opacity-75">-</span>
                        </td>
                        <td class="text-nowrap text-end">
                          <router-link
                            :to="`detail-examination?type=umum&date=${req.examination_date}&userId=${req.userId}`"
                            class="btn btn-sm btn-outline-secondary me-1"
                            title="Diagnosa"
                          >
                            <i class="ti ti-stethoscope fs-3"></i>
                          </router-link>
                          <router-link
                            :to="`/form-user?type=responden&userId=${req.userId}`"
                            class="btn btn-sm btn-outline-primary"
                            title="Detail"
                          >
                            <i class="ti ti-user fs-3"></i>
                          </router-link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <b-pagination
                  class="justify-content-center"
                  v-model="page"
                  :total-rows="dataList.length"
                  :per-page="pageSize"
                  prev-text="Previous"
                  next-text="Next"
                  @change="handlePageChange"
                  size="md"
                ></b-pagination>
              </div>

              <div
                class="tab-pane fade"
                id="pills-1"
                role="tabpanel"
                aria-labelledby="pills-1-tab"
                tabindex="0"
              >
                <div class="table-responsive">
                  <table class="table align-middle table-striped table-hover">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th class="w-25" scope="col">
                          <a href="#" class="link-dark">
                            Nama Lengkap
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th scope="col">
                          <a href="#" class="link-dark">
                            NIK
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-nowrap" scope="col">Tujuan Pemeriksaan</th>
                        <th class="text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Usia Kehamilan
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            HPL
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Tanggal
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            No. Antrian
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-end" scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          v-if="kontrolKehamilanList.length == 0"
                          colspan="12"
                          align="center"
                        >There is no data for this page</td>
                      </tr>
                      <tr v-for="(req, idx) in kontrolKehamilanList" :key="req.id">
                        <th scope="row">{{ idx + 1 }}</th>
                        <td class="text-nowrap">{{ req.fullname }}</td>
                        <td>{{ displayValue(req.nik) }}</td>
                        <td class="text-nowrap">
                          <ul v-if="req.examination_purpose" class="nav small flex-column">
                            <li
                              v-for="(item, index) in req.examination_purpose.split(',')"
                              :key="index"
                            >
                              <i class="ti ti-point-filled fs-1"></i>
                              {{ item }}
                            </li>
                          </ul>
                        </td>
                        <td class="text-center">{{ req.usia_kehamilan }} Minggu</td>
                        <td class="text-center">{{ formatDate(req.hpl) || '-' }}</td>
                        <td class="text-center">{{ formatDate(req.control_date) }}</td>
                        <td class="text-center">
                          <span class="badge text-bg-dark bg-opacity-75">-</span>
                        </td>
                        <td class="text-nowrap text-end">
                          <router-link
                            :to="`detail-examination?type=kehamilan&date=${req.control_date}&userId=${req.userId}&id=${req.id}`"
                            class="btn btn-sm btn-outline-secondary me-1"
                            title="Diagnosa"
                          >
                            <i class="ti ti-stethoscope fs-3"></i>
                          </router-link>
                          <router-link
                            :to="`/form-user?type=responden&userId=${req.userId}`"
                            class="btn btn-sm btn-outline-primary"
                            title="Detail"
                          >
                            <i class="ti ti-user fs-3"></i>
                          </router-link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <b-pagination
                  class="justify-content-center"
                  v-model="page"
                  :total-rows="kontrolKehamilanList.length"
                  :per-page="pageSize"
                  prev-text="Previous"
                  next-text="Next"
                  @change="handlePageChange"
                  size="md"
                ></b-pagination>
              </div>

              <div
                class="tab-pane fade"
                id="pills-3"
                role="tabpanel"
                aria-labelledby="pills-3-tab"
                tabindex="2"
              >
                <div class="table-responsive">
                  <table class="table align-middle table-striped table-hover">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th class="w-25" scope="col">
                          <a href="#" class="link-dark">
                            Nama Lengkap
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th scope="col">
                          <a href="#" class="link-dark">
                            NIK
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-nowrap" scope="col">Catatan Medis</th>
                        <th class="text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Waktu Kedatangan
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Waktu Persalinan
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Status Persalinan
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-end" scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          v-if="persalinanList.length == 0"
                          colspan="12"
                          align="center"
                        >There is no data for this page</td>
                      </tr>
                      <tr v-for="(req, idx) in persalinanList" :key="req.id">
                        <th scope="row">{{ idx + 1 }}</th>
                        <td
                          class="text-nowrap"
                        >{{ safeGet(req, 'user_pregnancies.user.user_profile.fullname') }}</td>
                        <td>{{ displayValue(safeGet(req, 'user_pregnancies.user.user_profile.nik')) }}</td>
                        <!-- <td class="text-nowrap">
                          <ul v-if="req.examination_purpose" class="nav small flex-column">
                            <li
                              v-for="(item, index) in req.examination_purpose.split(',')"
                              :key="index"
                            >
                              <i class="ti ti-point-filled fs-1"></i>
                              {{ item }}
                            </li>
                          </ul>
                        </td>-->
                        <td class="">{{ req.remark }}</td>
                        <td class="text-center">{{ formatDate(req.created_date) }}</td>
                        <td class="text-center">{{ formatDate(req.delivery_date) }}</td>
                        <td class="text-center">
                          <template v-if="req && req.delivery_status">
                            <small
                              :class="req.delivery_status? 'text-bg-success' : 'text-bg-danger'"
                              class="badge fs-1 bg-opacity-75"
                            >{{ req.delivery_status ? 'Sudah' : 'Belum' }}</small>
                          </template>
                        </td>
                        <td class="text-nowrap text-end">
                          <router-link
                            :to="`detail-examination?type=persalinan&date=${req.created_date}&userId=${safeGet(req, 'user_pregnancies.user.id')}&id=${req.id}`"
                            class="btn btn-sm btn-outline-secondary me-1"
                            title="Diagnosa"
                          >
                            <i class="ti ti-stethoscope fs-3"></i>
                          </router-link>
                          <router-link
                            :to="`/form-user?type=responden&userId=${safeGet(req, 'user_pregnancies.user.id')}`"
                            class="btn btn-sm btn-outline-primary"
                            title="Detail"
                          >
                            <i class="ti ti-user fs-3"></i>
                          </router-link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <b-pagination
                  class="justify-content-center"
                  v-model="page"
                  :total-rows="persalinanList.length"
                  :per-page="pageSize"
                  prev-text="Previous"
                  next-text="Next"
                  @change="handlePageChange"
                  size="md"
                ></b-pagination>
              </div>

              <div
                class="tab-pane fade"
                id="pills-4"
                role="tabpanel"
                aria-labelledby="pills-4-tab"
                tabindex="3"
              >
                <div class="table-responsive">
                  <table class="table align-middle table-striped table-hover">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th class="w-25" scope="col">
                          <a href="#" class="link-dark">
                            Nama Lengkap
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th scope="col">
                          <a href="#" class="link-dark">
                            NIK
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-nowrap" scope="col">Profil Kehamilan</th>
                        <th class="text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Waktu Kelahiran
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-center text-nowrap" scope="col">
                          <a href="#" class="link-dark">
                            Jenis Persalinan
                            <i class="ti ti-caret-up-down-filled"></i>
                          </a>
                        </th>
                        <th class="text-end" scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          v-if="postpartumList.length == 0"
                          colspan="12"
                          align="center"
                        >There is no data for this page</td>
                      </tr>
                      <tr v-for="(req, idx) in postpartumList" :key="req.id">
                        <th scope="row">{{ idx + 1 }}</th>
                        <td
                          class="text-nowrap"
                        >{{ req.fullname  }}</td>
                        <td>{{ displayValue(req.nik) }}</td>
                        <td class="">{{ req.profile_kehamilan }}</td>
                        <td class="text-center">{{ formatDate(req.delivery_date) }}</td>
                        <td class="text-center">
                          <template v-if="req && req.delivery_type">
                            <small
                              :class="req.delivery_type == 'Normal'? 'text-bg-success' : 'text-bg-danger'"
                              class="badge fs-1 bg-opacity-75"
                            >{{ req.delivery_type }}</small>
                          </template>
                        </td>
                        <td class="text-nowrap text-end">
                          <router-link
                            :to="`detail-examination?type=postpartum&date=${req.delivery_date}&userId=${req.userId}&id=${req.id}`"
                            class="btn btn-sm btn-outline-secondary me-1"
                            title="Diagnosa"
                          >
                            <i class="ti ti-stethoscope fs-3"></i>
                          </router-link>
                          <router-link
                            :to="`/form-user?type=responden&userId=${req.userId}`"
                            class="btn btn-sm btn-outline-primary"
                            title="Detail"
                          >
                            <i class="ti ti-user fs-3"></i>
                          </router-link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <b-pagination
                  class="justify-content-center"
                  v-model="page"
                  :total-rows="postpartumList.length"
                  :per-page="pageSize"
                  prev-text="Previous"
                  next-text="Next"
                  @change="handlePageChange"
                  size="md"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import Highlight from '../components/Highlight.vue'
import EmptyPlaceholder from '../components/EmptyPlaceholder.vue'
import { allMixin } from '@/mixins/allMixin.js'

export default {
	mixins: [allMixin],
	components: {
		Highlight,
		EmptyPlaceholder
	},
	data() {
		return {
			token: localStorage.getItem('token'),
			cariTitle: '',
			order: 'desc',
			page: 1,
			pageSize: 30,
			pageSizes: [10, 20, 50]
		}
	},
	created() {
		if (!this.token) {
			this.$router.push('/login')
		}
		this.getDataList()
		// this.getDataList2()
		// this.$store.commit("settings/setMenuActive", "dc-location");
		// this.$store.dispatch("auth/getNotif");
		// this.$store.dispatch('location/getDataSecond', {
		// 	url: `medical_examination`,
		// 	params: {
		// 		offset: 0,
		// 		limit: 10000,
		// 		order: 'desc'
		// 	}
		// })
		// this.$store.dispatch('location/getDataThird', {
		// 	url: `users`,
		// 	params: {
		// 		type: 'patient',
		// 		offset: 0,
		// 		limit: 10000,
		// 		order: 'desc'
		// 	}
		// })
	},
	computed: {
		...mapGetters({
			persalinanList: 'location/getDCLocation',
			// countDataList: 'location/getCountDCLocation',
			kontrolKehamilanList: 'location/getDataPayload',
			dataList: 'location/getDataThird',
			postpartumList: 'location/getDataPayload2'
		}),
		userId: {
			// getter
			get() {
				return this.$route.query.userId || ''
			}
		}
	},
	methods: {
		getDataList(reset_pagination, from = 'all') {
			if (reset_pagination) {
				this.page = 1
			}
			this.$store
				.dispatch('location/getDataThird', {
					url: `user_examination`,
					params: {
						fullname: this.cariTitle,
						userId: this.userId,
						offset: this.page - 1,
						limit: this.pageSize,
						order: this.order
					}
				})
				.then(() => {
					console.log('doneeeeeeeeeee')
				})
			this.getDataList2()
			this.getDataList3()
			this.getDataList4()
		},
		handlePageChange(value) {
			this.page = value
			this.getDataList()
		},
		handlePageSizeChange(event) {
			this.pageSize = parseInt(event.target.value)
			this.page = 1
			this.getDataList()
		},
		getDataList2(reset_pagination, from = 'all') {
			if (reset_pagination) {
				this.page = 1
			}
			this.$store
				.dispatch('location/getDataPayload', {
					url: `user_pregnancies_data`,
					params: {
						fullname: this.cariTitle,
						userId: this.userId,
						offset: this.page - 1,
						limit: this.pageSize,
						order: this.order
					}
				})
				.then(() => {
					console.log('doneeeeeeeeeee')
				})
		},
		getDataList3(reset_pagination, from = 'all') {
			if (reset_pagination) {
				this.page = 1
			}
			this.$store
				.dispatch('location/getData', {
					url: `user_delivery_journals`,
					params: {
						fullname: this.cariTitle,
						userId: this.userId,
						offset: this.page - 1,
						limit: this.pageSize,
						order: this.order
					}
				})
				.then(() => {
					console.log('doneeeeeeeeeee')
				})
		},
		getDataList4(reset_pagination, from = 'all') {
			if (reset_pagination) {
				this.page = 1
			}
			this.$store
				.dispatch('location/getDataPayload2', {
					url: `user_pregnancies`,
					params: {
						statusId: 12,
						fullname: this.cariTitle,
						userId: this.userId,
						offset: this.page - 1,
						limit: this.pageSize,
						order: this.order
					}
				})
				.then(() => {
					console.log('doneeeeeeeeeee')
				})
		},
		displayValue(value) {
			if (value === null || value === 'null' || value === undefined || value === 'undefined' || value === '') {
				return '-'
			}
			return value
		}
	}
}
</script>

